module.exports = __webpack_public_path__ + "assets/img/ts-0.1f20c116.png";